export const statTypeOptions = {
  data () {
    return {
      options_with_per_game: {
        'label': 'Stat Type',
        'data': [
          {'id': 'Totals', 'text': 'Totals'},
          {'id': 'PerGame', 'text': 'Per Game'},
          {'id': 'Per100Possessions', 'text': 'Per 100 Possessions'}
        ]
      },
      options_without_per_game: {
        'label': 'Stat Type',
        'data': [
          {'id': 'Totals', 'text': 'Totals'},
          {'id': 'Per100Possessions', 'text': 'Per 100 Possessions'}
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/stat_type_options.js